<template>
    <div class="main-wrap">
        <Title :title="title" />
        <Classify v-model:active="classifyActive" :data="classify" :label-key="labelKey" @change="changeClassify" />
        <!-- <el-button class="link" type="primary" link @click="goSquare" v-if="classify.length">更多＞</el-button> -->
        <ColumnList class="project-list" :data="list" column="2" gap="24px" v-if="list.length">
            <template #default="{ item }">
                <Card :image="item.cover" label-num="2" border>
                    <template #title-text>
                        <div class="title-ellipsis" :title="item.title">{{ item.title }}</div>
                    </template>
                    <template #label-text-1 v-if="item.achievementTypeDesc">
                        <span class="ellipsis" :title="item.achievementTypeDesc">成果类型：{{ item.achievementTypeDesc }}</span>
                    </template>
                    <template #label-text-2 v-if="item.sourceType">
                        <span class="ellipsis" :title="sourceName(item.sourceType)">成果来源：{{ sourceName(item.sourceType) }}</span>
                    </template>
                    <template #desc-text v-if="item.author">
                        <span class="ellipsis">作者：{{ item.author }}</span>
                    </template>
                </Card>
            </template>
        </ColumnList>
        <NoData info="抱歉，内容正在更新中，请稍后~" url="no-item.png" v-else />
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { Clock } from '@element-plus/icons-vue'
import { pageJump } from '@/global/location-transfer'
import Card from '@/views/scientific-research/components/card.vue'
import Title from '@/views/scientific-research/components/title.vue'
import Classify from '@/views/scientific-research/components/classify.vue'
import ColumnList from '@/views/shenzhen/components/column-list.vue'
import NoData from '@/components/no-data.vue'
import dayjs from 'dayjs'

const props = defineProps({
    title: {
        type: [String, Number],
        default: '',
    },
    projectType: {
        type: [String, Number],
        default: '',
    },
})

onMounted(init)

// 初始化
const loaded = ref(true)
async function init() {
    loaded.value = true
    await Promise.allSettled([getClassify()])
    await changeClassify()
    loaded.value = false
}

// 获取分类
const labelKey = 'name'
const classify = ref([])
async function getClassify() {
    try {
        const res = await G_transmit('escHomeGetProjectType', {})
        classify.value = [{ [labelKey]: '全部' }].concat(res?.data || [])
    } catch (error) {
        classify.value = []
    }
}

// 分类选择
const classifyActive = ref()
const classifyValues = computed(() => classify.value?.[classifyActive.value])
async function changeClassify(index) {
    classifyActive.value = index || 0
    await getDataList()
}

// 获取数据列表
const list = ref([])
const projectType = computed(() => classifyValues.value?.code)
async function getDataList() {
    try {
        const data = { projectType: classifyValues.value?.code, pageSize: 4 }
        const res = await G_transmit('escHomeAchievementList', { data })
        list.value = res?.data || []
    } catch (error) {
        list.value = []
    }
}

// 成果类型
function sourceName(type) {
    const source = [
        { name: '科研组上传', value: 1 },
        { name: '项目选拔', value: 2 },
    ]
    return source.find(item => item.value == type)?.name
}

function goSquare() {
    const query = { type: projectType.value }
    pageJump({ name: 'scientificResearchResultCenter', query }, true)
}
</script>

<style lang="scss" scoped>
.main-wrap {
    gap: 24px;
    display: flex;
    flex-flow: column;
    position: relative;
    .title {
        align-self: center;
    }
    .link {
        position: absolute;
        top: 68px;
        right: 0;
    }
    .project-list {
        :deep {
            .image {
                width: 300px;
                height: 160px;
            }
        }
    }
    .icon {
        font-size: 14px;
    }
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .title-ellipsis {
        line-clamp: 2;
        max-height: 44px;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}
</style>
